/**
 * @generated SignedSource<<1c017cdcb757a236faa99b0040876410>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UploadModalQuery$variables = {};
export type UploadModalQuery$data = {
  readonly viewer: {
    readonly account: {
      readonly billingAccount: {
        readonly audioUploadSizeLimitBytes: number | null;
        readonly videoUploadSizeLimitBytes: number | null;
      };
      readonly " $fragmentSpreads": FragmentRefs<"UploadModal_RemainingUploadCredits_account">;
    };
    readonly recordingsAndClips: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly detectedLanguage?: string | null;
        };
      }>;
    };
  };
};
export type UploadModalQuery = {
  response: UploadModalQuery$data;
  variables: UploadModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": "videoUploadSizeLimitBytes",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "ai_upload_video_size_bytes"
    }
  ],
  "kind": "ScalarField",
  "name": "usageLimitForFeature",
  "storageKey": "usageLimitForFeature(feature:\"ai_upload_video_size_bytes\")"
},
v1 = {
  "alias": "audioUploadSizeLimitBytes",
  "args": [
    {
      "kind": "Literal",
      "name": "feature",
      "value": "ai_upload_audio_size_bytes"
    }
  ],
  "kind": "ScalarField",
  "name": "usageLimitForFeature",
  "storageKey": "usageLimitForFeature(feature:\"ai_upload_audio_size_bytes\")"
},
v2 = [
  {
    "kind": "Literal",
    "name": "entityType",
    "value": "recordings"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detectedLanguage",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "UploadModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/)
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UploadModal_RemainingUploadCredits_account"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "MeetingRecordingConnection",
            "kind": "LinkedField",
            "name": "recordingsAndClips",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "recordingsAndClips(entityType:\"recordings\",first:1)"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "UploadModalQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Account",
            "kind": "LinkedField",
            "name": "account",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "BillingAccount",
                "kind": "LinkedField",
                "name": "billingAccount",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  (v1/*: any*/),
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionState",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subscriptionBillingCycleAnchor",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountUploadCredits",
                "kind": "LinkedField",
                "name": "uploadCredits",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedUploadCredits",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "includedCreditsUsedCurrentCycle",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "MeetingRecordingConnection",
            "kind": "LinkedField",
            "name": "recordingsAndClips",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "MeetingRecordingEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "recordingsAndClips(entityType:\"recordings\",first:1)"
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1834a539e11e5a3e914b7cf83a4a48f8",
    "id": null,
    "metadata": {},
    "name": "UploadModalQuery",
    "operationKind": "query",
    "text": "query UploadModalQuery {\n  viewer {\n    account {\n      billingAccount {\n        videoUploadSizeLimitBytes: usageLimitForFeature(feature: ai_upload_video_size_bytes)\n        audioUploadSizeLimitBytes: usageLimitForFeature(feature: ai_upload_audio_size_bytes)\n        id\n      }\n      ...UploadModal_RemainingUploadCredits_account\n      id\n    }\n    recordingsAndClips(first: 1, entityType: recordings) {\n      edges {\n        node {\n          __typename\n          ... on MeetingRecording {\n            detectedLanguage\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment UploadModal_RemainingUploadCredits_account on Account {\n  billingAccount {\n    subscriptionState\n    subscriptionBillingCycleAnchor\n    id\n  }\n  uploadCredits {\n    includedUploadCredits\n    includedCreditsUsedCurrentCycle\n  }\n}\n"
  }
};
})();

(node as any).hash = "4104bc694a0487c7344aa455fb879b95";

export default node;
